import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleOutlinedError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1951 0.25C4.67508 0.25 0.205078 4.73 0.205078 10.25C0.205078 15.77 4.67508 20.25 10.1951 20.25C15.7251 20.25 20.2051 15.77 20.2051 10.25C20.2051 4.73 15.7251 0.25 10.1951 0.25ZM10.2051 18.25C5.78508 18.25 2.20508 14.67 2.20508 10.25C2.20508 5.83 5.78508 2.25 10.2051 2.25C14.6251 2.25 18.2051 5.83 18.2051 10.25C18.2051 14.67 14.6251 18.25 10.2051 18.25ZM9.20508 13.25H11.2051V15.25H9.20508V13.25ZM9.20508 5.25H11.2051V11.25H9.20508V5.25Z",
		fill: "#D32F2F"
	})
});
export default SvgCircleOutlinedError;
